module.exports = __webpack_public_path__ + "img/hr-brown-asterisk-13.235e8c6f.png";